<script>
  import Vue from 'vue'
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'

  export default {
    name: 'app-modal',

    data () {
      return {
        component: null,
        title: null,
        okOnly: false,
        okTitle: 'OK',
        cancelTitle: 'Cancel'
      }
    },

    computed: {
      ...mapState('app', {
        modalVisible: state => state.modalVisible,
        modalComponent: state => state.modalComponent
      }),
      visible: {
        set (isVisible) {
          if (!isVisible) {
            return this.$store.dispatch('app/hideModal')
          }
        },
        get () {
          return this.modalVisible
        }
      }
    },

    watch: {
      modalComponent (componentName) {
        if (!componentName) {
          return
        }

        this.component = Vue.component(_.kebabCase(componentName), () => import(`@/components/modals/${componentName}`))
      }
    },

    methods: {
      ...mapActions('app', ['hideModal']),

      handleOk (e) {
        if (typeof this.$refs.child.handleOk === 'function') {
          this.$refs.child.handleOk(e)
        }
      },

      handleCancel (e) {
        if (typeof this.$refs.child.handleCancel === 'function') {
          this.$refs.child.handleCancel(e)
        }
      }
    }
  }
</script>

<template>
  <b-modal lazy
           centered
           no-fade
           no-stacking
           no-close-on-background
           v-model="visible"
           class="modal-fullscreen"
           :title="title"
           :ok-only="okOnly"
           :ok-title="okTitle"
           :cancel-title="cancelTitle"
           @ok="handleOk"
           @cancel="handleCancel">
    <component ref="child"
               :is="component"
               v-on:update:title="title = $event"
               v-on:update:ok-only="okOnly = $event"
               v-on:update:ok-title="okTitle = $event"
               v-on:update:cancel-title="cancelTitle = $event"
    />
  </b-modal>
</template>
